import { gql } from '@apollo/client';
import { PaymentSource } from '../../../constants';

export type BillingAddress = {
  __typename: 'RestBillingAddress';
  countryCode: string;
  extendedAddress: string | null;
  id: string | null;
  locality: string;
  postalCode: string;
  region: string;
  streetAddress: string;
};

export type Psd2AuthData = {
  __typename: 'RestPsd2AuthData';
  threeDSServerTransID: string;
  threeDSMethodURL: string;
  acsURL: string;
  acsTransID: string;
  messageVersion: string;
  threeDSResponseServerTransID: string;
  threeDSMethodNotificationURL: string;
  issuerUrl: string;
  md: string;
  paRequest: string;
  termUrl: string;
};

export type PaymentMethodAttributes = {
  __typename: 'RestPaymentMethodAttributes';
  cardType?: string;
  cardTypeName?: string;
  cardholderName?: string;
  expirationDate: string;
  isValid?: boolean;
  lastFour: string;
  source: PaymentSource;
  resultCode: string | null;
  billingAddress: BillingAddress | null;
  psd2AuthData: Psd2AuthData | null;
};

export type PaymentMethod = {
  __typename: 'RestPaymentMethod';
  id: string;
  attributes: PaymentMethodAttributes;
};

export type PaymentMethodsQuery = {
  paymentMethods: {
    __typename: 'RestPaymentMethods';
    data: PaymentMethod[];
  };
};

export const PAYMENT_METHOD_ATTRIBUTES_FRAGMENT = gql`
  fragment PaymentMethodAttributesFragment on RestPaymentMethodAttributes {
    cardType: card_type
    cardTypeName: card_type_name
    cardholderName: cardholder_name
    expirationDate: expiration_date
    isValid: is_valid_card
    lastFour: last_four
    source
    resultCode: result_code
    billingAddress: billing_address @type(name: "RestBillingAddress") {
      countryCode: country_code_alpha2
      extendedAddress: extended_address
      id
      locality
      postalCode: postal_code
      region
      streetAddress: street_address
    }
    psd2AuthData: psd2_auth_data @type(name: "RestPsd2AuthData") {
      threeDSServerTransID: threeds2threeDSServerTransID
      threeDSMethodURL: threeds2threeDSMethodURL
      acsURL: threeds2threeDS2ResponseDataacsURL
      acsTransID: threeds2threeDS2ResponseDataacsTransID
      messageVersion: threeds2threeDS2ResponseDatamessageVersion
      threeDSResponseServerTransID: threeds2threeDS2ResponseDatathreeDSServerTransID
      threeDSMethodNotificationURL: threeds_method_notification_url
      issuerUrl: issuer_url
      md
      paRequest: pa_request
      termUrl: term_url
    }
  }
`;

export const PAYMENT_METHOD_FRAGMENT = gql`
  fragment PaymentMethodFragment on RestPaymentMethod {
    id
    attributes @type(name: "RestPaymentMethodAttributes") {
      ...PaymentMethodAttributesFragment
    }
  }
  ${PAYMENT_METHOD_ATTRIBUTES_FRAGMENT}
`;

export const PAYMENT_METHODS_QUERY = gql`
  query PaymentMethodsQuery {
    paymentMethods @rest(type: "RestPaymentMethods", endpoint: "cart", path: "/v3.5/payments") {
      data @type(name: "RestPaymentMethod") {
        ...PaymentMethodFragment
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
